import { useTranslation } from 'react-i18next';
import type { BeneficiaryInformationInvestment } from '../types';
import { isBeneficiaryInformationInvestmentType } from '../util';

export interface InvestmentBeneficiaryInformationProps {
  investment: Pick<BeneficiaryInformationInvestment, 'investmentType'> & {
    beneficiaryInformation?: string | null;
  };
}

export function InvestmentBeneficiaryInformation({ investment }: InvestmentBeneficiaryInformationProps) {
  const { t } = useTranslation('investment');

  if (!isBeneficiaryInformationInvestmentType(investment.investmentType)) return null;

  const label = t('beneficiary-information-label');
  const beneficiaryInformation = investment.beneficiaryInformation?.trim();

  return (
    <>
      <div className="mt-8 text-sm text-darkMode-gray-light">{label}</div>
      <div className="whitespace-pre-wrap text-lg text-white" aria-label={label}>
        {beneficiaryInformation || t('beneficiary-information-empty')}
      </div>
    </>
  );
}
